"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addImpliedTimeUnits = exports.reverseTimeUnits = void 0;

function reverseTimeUnits(timeUnits) {
  const reversed = {};

  for (const key in timeUnits) {
    reversed[key] = -timeUnits[key];
  }

  return reversed;
}

exports.reverseTimeUnits = reverseTimeUnits;

function addImpliedTimeUnits(components, timeUnits) {
  const output = components.clone();
  let date = components.dayjs();

  for (const key in timeUnits) {
    date = date.add(timeUnits[key], key);
  }

  if ("day" in timeUnits || "d" in timeUnits || "week" in timeUnits || "month" in timeUnits || "year" in timeUnits) {
    output.imply("day", date.date());
    output.imply("month", date.month() + 1);
    output.imply("year", date.year());
  }

  if ("second" in timeUnits || "minute" in timeUnits || "hour" in timeUnits) {
    output.imply("second", date.second());
    output.imply("minute", date.minute());
    output.imply("hour", date.hour());
  }

  return output;
}

exports.addImpliedTimeUnits = addImpliedTimeUnits;